import { useState } from 'react';
import { useActivities } from '../hooks/useActivities.js';
import AllRunsMap from '../components/AllRunsMap.jsx';
import MapFilter from '../components/MapFilter.jsx';
import Footer from '../components/Footer.jsx';
import Loading from '../components/Loading.jsx';

/** Full-screen map of every one of Logan's runs, with the date filter. */
export default function RunMapPage() {
  const { data, loading } = useActivities();
  const [timeFrame, setTimeFrame] = useState('');

  if (loading) return <Loading />;

  return (
    <>
      <MapFilter onFilter={setTimeFrame} />
      <AllRunsMap data={data} timeFrame={timeFrame} style={{ height: '100vh', width: '100vw' }} />
      <Footer />
    </>
  );
}
